<template>
  <div>
    <b-row>
      <b-col class="d-flex">
        <backlink class="mt-20" />
        <div class="flex-fill">
          <h1>
            {{ config.singleLabel }}
            <div v-if="!isBusy" class="subtitle">{{ values[config.titleField] }}</div>
          </h1>
        </div>
        <div v-if="values.id" class="text-right">
          <slot name="top-buttons" :rawValues="rawValues" :values="values"></slot>
          <b-button variant="outline-primary" size="lg" v-if="config.useEditModal &&
            !config.hideActionEditButton &&
            ((config.editCondition && config.editCondition(values)) || !config.editCondition) &&
            config.authFeature &&
            $store.getters['auth/isAuthorized'](config.authFeature + '_edit')
            " @click="openFormModal(values.id)">
            Modifier la fiche
            <i class="far fa-pencil ml-10"></i>
          </b-button>
          <b-button variant="outline-primary" size="lg" v-if="!config.useEditModal &&
            !config.hideActionEditButton &&
            ((config.editCondition && config.editCondition(values)) || !config.editCondition) &&
            config.authFeature &&
            $store.getters['auth/isAuthorized'](config.authFeature + '_edit')
            " :to="{ name: config.editRouteName, params: { id: values.id } }">
            Modifier la fiche
            <i class="far fa-pencil ml-10"></i>
          </b-button>
          <b-button variant="outline-primary ml-10" size="lg" v-if="!config.hideActionPdfButton"
            @click="$root.exportPdf(exportPdfData)">
            Exporter en PDF
            <i class="far fa-file-alt fa-lg ml-10"></i>
          </b-button>
        </div>
      </b-col>
    </b-row>
    <div v-if="isBusy" class="loader"></div>
    <p v-if="isBusy" class="text-center">Les données sont en cours de chargement...</p>
    <b-row v-else>
      <b-col>
        <div class="ibox">
          <div class="ibox-content divided">
            <b-row>
              <b-col>
                <dl class="detail-list">
                  <template v-for="field in fields">
                    <dt :key="field.name + '_dt'">{{ field.label }} :</dt>
                    <dd :key="field.name + '_dd'"
                      :class="{ 'detail-list__value--empty': !values[field.name] && !field.displayDetailHtml }">
                      <router-link v-if="field.detailLink && values[field.name]"
                        :to="{ name: field.detailLink, params: { id: rawValues[field.name].id } }" target="_blank">{{
                          values[field.name] }}</router-link>
                      <a v-else-if="field.link && values[field.name]"
                        :href="field.link($root, values[field.name], values)" :target="field.linkTarget || '_self'">{{
                          values[field.name] }}</a>
                      <div v-else-if="field.displayDetailHtml" v-html="values[field.name] || '-'"></div>
                      <template v-else>{{ values[field.name] || "-" }}</template>
                    </dd>
                  </template>
                </dl>
              </b-col>
              <b-col v-if="values.created_at || values.updated_at">
                <div class="underbox">
                  <i class="icone far fa-calendar-alt fa-lg"></i>
                  <dl class="detail-dates">
                    <dt v-if="values.created_at">Création :</dt>
                    <dd v-if="values.created_at">
                      {{ values.created_at | moment("dddd DD MMMM YYYY à HH:mm") }}
                      <!-- L'API sérialise souvent created_by/updated_by en identifiant nu :
                           on n'affiche l'auteur que lorsqu'on a réellement un nom, sinon la
                           ligne s'affichait « par () » avec un lien mailto vide. -->
                      <div v-if="authorName(values.created_by)" class="detail-dates__author">
                        par {{ authorName(values.created_by) }}
                        <a v-if="authorEmail(values.created_by)" :href="'mailto:' + authorEmail(values.created_by)"
                          target="_blank">{{ authorEmail(values.created_by) }}</a>
                      </div>
                    </dd>
                    <dt v-if="values.updated_at">Dernière modification :</dt>
                    <dd v-if="values.updated_at">
                      {{ values.updated_at | moment("dddd DD MMMM YYYY à HH:mm") }}
                      <div v-if="authorName(values.updated_by)" class="detail-dates__author">
                        par {{ authorName(values.updated_by) }}
                        <a v-if="authorEmail(values.updated_by)" :href="'mailto:' + authorEmail(values.updated_by)"
                          target="_blank">{{ authorEmail(values.updated_by) }}</a>
                      </div>
                    </dd>
                  </dl>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="lists && lists.length">
      <b-col v-for=" list  in  lists " :key="list.name">
        <div class="ibox">
          <div class="ibox-title">
            <i v-if="list.icone" :class="['far', 'fa-' + list.icone]"></i>
            {{ list.label }}
          </div>
          <div class="ibox-content">
            <div class="table-wrapper">
              <b-table hover show-empty :fields="lists_fields[list.name]" :items="listsItems[list.name]">
                <template slot="empty" slot-scope="scope">
                  <div class="text-center mt-2">Cette liste est vide pour le moment</div>
                </template>
                <template v-for=" field  in  lists_fields[list.name] " :slot="field.key" slot-scope="data">
                  <a :key="field.key" v-if="list.config.fields.find((item) => item.name == field.key).link" :href="list.config.fields
                    .find((item) => item.name == field.key)
                    .link($root, data.value, data.item)
                    " :target="list.config.fields.find((item) => item.name == field.key).linkTarget ||
    '_self'
    ">{{ data.value }}</a>
                  <template v-else>{{ data.value }}</template>
                </template>
                <template :slot="list.config.titleField" slot-scope="data">
                  <router-link :to="{ name: list.config.detailRouteName, params: { id: data.item.id } }">{{ data.value
                  }}</router-link>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <AdminModalForm v-if="config.useEditModal" :config="config" :id_to_edit="id_to_edit" />
  </div>
</template>

<script>
import AdminModalForm from "@/components/Global/AdminModalForm";

export default {
  name: "AdminDetail",
  components: {
    AdminModalForm,
  },
  props: ["config"],
  data() {
    return {
      fields: {},
      lists: [],
      lists_fields: {},
      isBusy: false,
      id_to_edit: null,
    };
  },
  computed: {
    rawValues: function () {
      return (
        this.$store.getters[this.config.storeNamespace + "/getItem"](this.$route.params.id) || {}
      );
    },
    values: function () {
      return this.$root.formatData(
        this.rawValues,
        this.config.fields.filter((field) => field.inDetail == true)
      );
    },
    exportPdfData: function () {
      let exportPdfData = {
        title: this.config.pdf_export_title
          ? this.config.pdf_export_title(this.rawValues, this.values, this)
          : this.values[this.config.titleField],
        link: this.config.pdf_export_link
          ? this.config.pdf_export_link(this.rawValues, this.values, this)
          : null,
        infos: [],
      };

      if (this.config.pdf_export_logo) {
        exportPdfData.logo = this.config.pdf_export_logo;
      }

      if (this.config.pdf_export_extra_content_before) {
        exportPdfData.extra_content_before = this.config.pdf_export_extra_content_before(
          this.rawValues,
          this.values,
          this
        );
      }

      if (this.config.pdf_export_custom_main_content) {
        exportPdfData.custom_main_content = this.config.pdf_export_custom_main_content(
          this.rawValues,
          this.values,
          this
        );
      } else {
        this.config.fields
          .filter((field) => field.inPdfExport == true)
          .forEach((field) => {
            exportPdfData.infos.push([
              field.label + " :",
              field.type == "yesno"
                ? this.values[field.name] == true
                  ? "Oui"
                  : "Non"
                : this.values[field.name] || null,
            ]);
          });
      }

      exportPdfData.lists = [];
      if (this.lists && this.lists.length) {
        this.lists.forEach((list) => {
          if (this.listsItems[list.name]) {
            let currentList = {
              label: list.label,
              infos: [this.lists_fields[list.name].map((f) => f.label)],
            };
            this.listsItems[list.name].forEach((item) => {
              let infosItem = [];
              list.fields.forEach((field) => {
                infosItem.push(item[field] || null);
              });
              currentList.infos.push(infosItem);
            });
            exportPdfData.lists.push(currentList);
          }
        });
      }

      if (this.config.pdf_export_extra_lists) {
        exportPdfData.lists.push(
          ...this.config.pdf_export_extra_lists(this.rawValues, this.values, this)
        );
      }

      if (this.config.pdf_export_extra_content_after) {
        exportPdfData.extra_content_after = this.config.pdf_export_extra_content_after(
          this.rawValues,
          this.values,
          this
        );
      }

      return exportPdfData;
    },
    listsItems: function () {
      let listsItems = {};
      if (this.lists && this.lists.length) {
        this.lists.forEach((list) => {
          if (this.values[list.name]) {
            listsItems[list.name] = this.$root.formatDatas(
              this.values[list.name],
              list.config.fields
            );
          }
        });
      }
      return listsItems;
    },
  },
  mounted() {
    let self = this;

    // Chargement des champs à afficher dans le détail depuis la config
    this.fields = this.config.fields.filter((field) => field.inDetail == true);

    this.isBusy = true;
    this.$store
      .dispatch(this.config.storeNamespace + "/getItem", {
        id: this.$route.params.id,
      })
      .then(() => {
        // Test si le contenu demandé est bien trouvé
        if (Object.entries(this.rawValues).length <= 0) {
          this.$toastr.error(
            "La fiche demandée n'a pas été trouvée. Assure-vous que l'URL saisie soit correcte."
          );
          setTimeout(function () {
            self.$router.go(-1);
          }, 5000);
          return;
        }

        // Gestion des listes additionnelles
        this.lists = this.config.fields.filter((field) => field.type == "list");
        if (this.lists && this.lists.length) {
          let lists_fields = {};
          this.lists.forEach((list) => {
            lists_fields[list.name] = [];

            list.fields.forEach((field) => {
              lists_fields[list.name].push({
                key: field,
                label: list.config.fields.find((f) => f.name == field).label,
              });
            });
          });
          this.lists_fields = lists_fields;
        }

        this.isBusy = false;
      });
  },
  methods: {
    openFormModal(id) {
      this.id_to_edit = id;
      this.$root.$emit("bv::show::modal", "admin_modal_form");
    },
    /**
     * Nom affichable d'un auteur. L'API renvoie tantôt l'objet utilisateur, tantôt
     * son seul identifiant (entier), tantôt null : seul le premier cas est affichable.
     * À défaut de nom, l'e-mail sert de repli.
     */
    authorName(author) {
      if (!author || typeof author !== "object") {
        return null;
      }
      const name = [author.firstname, author.lastname]
        .filter((part) => part && String(part).trim())
        .join(" ")
        .trim();

      return name || author.email || null;
    },
    /** E-mail de l'auteur, tant qu'il ne fait pas doublon avec le nom affiché. */
    authorEmail(author) {
      if (!author || typeof author !== "object" || !author.email) {
        return null;
      }

      return author.email === this.authorName(author) ? null : author.email;
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-dates__author {
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Global/AdminDetail.vue